import { motion } from "framer-motion";

export const ClassLevels = ({ eyebrow = "Classes by age", title, intro, levels, accent = "#4FA3C6" }) => {
  return (
    <section className="pb-20 md:pb-24" data-testid="class-levels">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-12">
          <span className="text-sm tracking-[0.2em] uppercase font-bold" style={{ color: accent }}>{eyebrow}</span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold tracking-tight text-[#0F172A] leading-tight">
            {title}
          </h2>
          {intro && <p className="mt-5 text-lg text-[#334155]">{intro}</p>}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {levels.map((l, i) => (
            <motion.div
              key={l.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative overflow-hidden bg-white rounded-[1.75rem] p-7 border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
              data-testid={`class-level-${i}`}
            >
              <span
                className="grid place-items-center w-14 h-14 rounded-2xl text-white shadow-md mb-5 group-hover:scale-110 transition-transform duration-300"
                style={{ backgroundColor: l.accent || accent }}
              >
                {l.icon}
              </span>
              <h3 className="font-heading text-xl font-bold tracking-tight text-[#0F172A]">{l.name}</h3>
              <span
                className="inline-block mt-2 text-sm font-bold px-3 py-1 rounded-full"
                style={{ backgroundColor: `${l.accent || accent}1A`, color: l.accent || accent }}
              >
                {l.age}
              </span>
              {l.note && <p className="mt-3 text-[#64748B] leading-relaxed">{l.note}</p>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
